import angular from 'angular';
import {
  ssDialogService,
  vmSharedModelService,
  loaderService,
} from 'app/services';
import {
  confirmDialog,
  actionIcon,
  alerts
} from 'app/components/global';
import addVendorProductDialog from './dialog.addVendorProductDialog';
import controller from './product.controller';
import directive from './product.directive';


export default angular.module('app.components.advisory.enterpriseModeling.product', [
  actionIcon,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  vmSharedModelService,
  addVendorProductDialog
])
  .directive('emProduct', directive)
  .controller('EMProductController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.product created');
